/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type ComponentRef, type OnDestroy, type OnInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FileUpload } from '@dm/ang';
import {
    type BaseRequestOptionsArgs, type Polling, type RestJob,
FormControl,
    FormGroup, HttpService, LazyloadService, PollingService, TabComponent, TimeService, UNPLACEHOLDER,
} from '@dm/core';
import { AuthService } from 'app/common/services';
import { PatchService } from 'app/common/services/patch.service';
import { SWITCH } from 'app/config';
import { LicenseManagementService } from 'app/feature/settings/license-management/license-management.service';
import { isUndefined } from 'lodash';
import { of, throwError } from 'rxjs';
import { catchError, finalize, switchMap } from 'rxjs/operators';

import { DetailCheckResultUpgradeComponent } from '../detail-check-result-upgrade/detail-check-result-upgrade.component';
import { SystemUpgradeComponent } from '../system-upgrade-panel/system-upgrade.component';
import {
type PreCheckParams, type StatusCount,
    CheckFileProcesses, CheckResult, CheckStatusE, CmoUpdSysStepTaskStatusE, DoneStatus,
    EvaluateProcesses, HotpatchUploadProcesses, PackageTypeE, Progress, UpgradeProcesses,
    UPLOAD_STATUS,
} from '../upgrade.const';
import { UpgradeService } from '../upgrade.service';
import { LicenseError, UpgradeStrService } from '../upgrade-str.service';

@Component({
    selector: 'app-system-upgrade-upload',
    templateUrl: './system-upgrade-upload.component.html',
    styleUrls: ['./system-upgrade-upload.component.scss'],
})
export class SystemUpgradeUploadComponent implements OnInit, OnDestroy {
    // 上传窗口显示
    @Input() show: boolean;
    // 升级面板组件
    @Input() upgrade: SystemUpgradeComponent;
    /**
     * 当前版本
     */
    @Input() currentVersion: string;
    @Input() activeIndex: number;

    @ViewChild('uploadEl') uploadEl: FileUpload;

    @ViewChild('detailContainerEle') detailContainerEle: ElementRef;

    @ViewChild('tab') tab: TabComponent;
    // 目标版本
    packageTargetVersion = UNPLACEHOLDER;
    // 热补丁目标版本
    hotpatchTargetVersion = UNPLACEHOLDER;
    UNPLACEHOLDER = UNPLACEHOLDER;
    // 上传包错误信息
    // errorMsg: string;
    // 升级包上传包路径
    uploadUrl: string;
    // 检查项文件上传路径
    checkFileUrl: string;
    // 热补丁上传路径
    hotpatchUrl: string;
    // 上传进度轮询
    uploadPolling: Polling;
    // 上传进度
    uploadProgress: number;
    // 上传进度条颜色
    /**
     * 开始上传大包的标记
     */
    startUploadBig = false;

    UPLOAD_STATUS = UPLOAD_STATUS;

    PackageTypeE = PackageTypeE;

    updateEvalScript = false;

    // 当前升级状态 preCheck、upgrade、verificatng
    upgradeStatus = {
        checkProgress: 0,
        status: CmoUpdSysStepTaskStatusE.Upgrading,
    };

    // 进度条动画。切换步骤时进度会重置，此时不应该有动画
    progressMotion = true;

    currentProcess: Progress;

    // 检查详情
    checkDetails = [];

    // 评估详情轮询
    checkResultPolling: Polling;

    // 是否执行过额外的轮询
    extraPolling = false;

    uploadMsg = '';

    // 禁用升级按钮
    upgradeBtnDisabled = true;

    hotpatchUploadEnable = false;

    i18n = this.str.i18n;
    sysUpProgressDesc = this.str.sysUpProgressDesc;

    onSelectPatch = this.patchService.onSelectPatch.bind(this);

    allCount = 0;
    sucCount = 0;
    failCount = 0;
    ignoreCount = 0;

    updateCheckFile = true;

    uploadOpts: BaseRequestOptionsArgs = {};

    Progress = Progress;

    CheckResult = CheckResult;

    backupLoading = false;
    // 是否显示备份
    isShowExport = false;
    // 是否导出成功
    isExportSucceed = false;
    // 是否导出License成功
    isExportLicenseSucceed = true;
    count: StatusCount = {
        all: 0,
        suc: 0,
        fail: 0,
        ignore: 0,
    };

    SWITCH = SWITCH;

    /**
     * 保存当前打开的详情页组件，用于数据双向沟通
     */
    detailComponent: ComponentRef<any>;

    /**
     * 当前打开的检查详情数据key
     *
     * 以检查详情的checkItem值作为key
     */
    checkDetailDataKey: string;

    backupTip = SWITCH.IS_DIRECT_MODE ? this.i18n.backupInfoWithoutLicense : this.i18n.backupInfoLab;
    vm: FormGroup;
    errorMessage;
    constructor(
        public str: UpgradeStrService,
        private http: HttpService,
        private poll: PollingService,
        private lazyLoad: LazyloadService,
        private patchService: PatchService,
        private service: UpgradeService,
        private authService: AuthService,
        private timeService: TimeService,
        private licenseManagementService: LicenseManagementService,
    ) { }

    ngOnInit(): void {
        this.initVm();
        this.show = true;
        this.uploadUrl = this.http.makeUrl('upgrade.systemUpgradeUpload').url;
        this.checkFileUrl = this.http.makeUrl('upgrade.upgradeCheckUpload').url;
        this.hotpatchUrl = this.http.makeUrl('upgrade.hotpatchInUpgradeUpload').url;

    }

    initVm(): void {
        this.vm = new FormGroup({
            targetVersion: new FormControl(''),
        }, { updateOn: 'change' });
        this.errorMessage = {
            targetVersion: {
                inValid: this.i18n.targetVersionInvalidTip,
            },
        };
    }

    selectCheckFile(): void {
        this.isShowExport = false;
        this.isExportSucceed = false;
        this.currentProcess = Progress.checkFileSelected;
        this.checkDetails = [];
    }

    startUploadCheckFile(): void {
        this.currentProcess = Progress.checkFileUploading;
        if (!this.authService.getTimeoutExcept()) {
            // 开始上传包,开启超时检测例外
            this.authService.enableTimeoutExcept();
        }
    }

    checkFileUploadCompelete(): void {
        this.currentProcess = Progress.checkFileUploadSuc;
    }

    checkFileUploadFailed(): void {
        this.currentProcess = Progress.checkFileUploadFailed;
    }

    checkFileUploadDisabled(currentProcess: Progress): boolean {
        const inCheckFileProgress = CheckFileProcesses.includes(currentProcess);
        const precheckDone = [
            Progress.evaluateFailed,
            Progress.evaluateSuc,
        ].includes(currentProcess);
        return currentProcess && !inCheckFileProgress && !precheckDone;
    }

    evaluateButtonShow(currentProcess: Progress): boolean {
        const inCheckFileProgress = CheckFileProcesses.includes(currentProcess);
        return inCheckFileProgress || !currentProcess;
    }

    evaluateButtonDisabled(currentProcess: Progress, updateCheckFile: boolean): boolean {
        return (currentProcess !== Progress.checkFileUploadSuc) && updateCheckFile;
    }

    retryButtonShow(currentProcess: Progress): boolean {
        const inCheckFileProgress = CheckFileProcesses.includes(currentProcess);
        return currentProcess && !inCheckFileProgress;
    }

    retryButtonDisabled(currentProcess: Progress): boolean {
        const precheckDone = [
            Progress.evaluateFailed,
            Progress.evaluateSuc,
        ].includes(currentProcess);
        return !precheckDone;
    }

    evaluateProcessIconShow(currentProcess: Progress): string {
        const inCheckFileProcesses = CheckFileProcesses.includes(currentProcess);
        return !inCheckFileProcesses && currentProcess;
    }

    evaluateProcessIcon = (currentProcess: Progress): string => {
        let icon = '';
        const inEvaluateProcesses = EvaluateProcesses.includes(currentProcess);
        const inCheckFileProcesses = CheckFileProcesses.includes(currentProcess);
        const afterEvaluate = !inCheckFileProcesses && !inEvaluateProcesses && currentProcess;
        if (inEvaluateProcesses) {
            icon = this.sysUpProgressDesc[currentProcess].icon;
        } else if (afterEvaluate) {
            icon = this.sysUpProgressDesc[Progress.evaluateSuc].icon;
        }
        return `#icon-${icon}`;
    };

    evaluateProcessText = (currentProcess: Progress, checkProgress: number): string => {
        let text = '';
        const inEvaluateProcesses = EvaluateProcesses.includes(currentProcess);
        const inCheckFileProcesses = CheckFileProcesses.includes(currentProcess);
        const afterEvaluate = !inCheckFileProcesses && !inEvaluateProcesses && currentProcess;
        if (inEvaluateProcesses) {
            if (currentProcess === Progress.evaluating) {
                text = checkProgress + '%';
            } else if (currentProcess === Progress.evaluateSuc) {
                text = this.i18n.success;
            } else if (currentProcess === Progress.evaluateFailed) {
                text = this.i18n.failed;
            }
        } else if (afterEvaluate) {
            text = this.sysUpProgressDesc[Progress.evaluateSuc].text;
        }
        return text;
    };

    upgradeShow(currentProcess: Progress, isExportSucceed: boolean): boolean {
        const inUpgradeProcesses = UpgradeProcesses.includes(currentProcess);
        return inUpgradeProcesses || isExportSucceed;
    }

    startUploadPackage(): void {
        this.currentProcess = Progress.packageUploading;
        this.packageTargetVersion = UNPLACEHOLDER;
        this.upgradeBtnDisabled = true;
    }

    packageUploadCompelete = (value: string): void => {
        this.currentProcess = Progress.packageUploadSuc;
        this.packageTargetVersion = value || UNPLACEHOLDER;
        if (!this.hotpatchUploadEnable) {
            this.upgradeBtnDisabled = false;
        }
    };

    packageUploadFailed = (): void => {
        this.currentProcess = Progress.packageUploadFail;
    };

    packageUploadDisabled(currentProcess: Progress, hotpatchUploadEnable: boolean): boolean {
        return HotpatchUploadProcesses.includes(currentProcess) || hotpatchUploadEnable;
    }

    hotPatchUploadShow(currentProcess: Progress): boolean {
        const inHotpatchProcesses = HotpatchUploadProcesses.includes(currentProcess);
        return currentProcess === Progress.packageUploadSuc || inHotpatchProcesses;
    }

    hotpatchUploadEnableChange = (value: boolean): void => {
        if (value) {
            this.upgradeBtnDisabled = true;
        } else {
            this.currentProcess = Progress.packageUploadSuc;
            this.upgradeBtnDisabled = false;
        }
    };

    hotpatchUploadEnableDisabled(currentProcess: Progress, value: boolean): boolean {
        const inHotpatchUploadProcesses = HotpatchUploadProcesses.includes(currentProcess);
        return value && inHotpatchUploadProcesses;
    }

    startUploadHotpatch = (): void => {
        this.currentProcess = Progress.hotpatchUploading;
        this.hotpatchTargetVersion = UNPLACEHOLDER;
        this.upgradeBtnDisabled = true;
    };

    hotpatchUploadCompelete = (value: string): void => {
        this.currentProcess = Progress.hotpatchUploadSuc;
        this.hotpatchTargetVersion = value || UNPLACEHOLDER;
        this.upgradeBtnDisabled = false;
    };

    hotpatchUploadFailed = (): void => {
        this.currentProcess = Progress.hotpatchUploadFail;
    };

    hotPatchUploadDisabled(currentProcess: Progress): boolean {
        return currentProcess === Progress.packageUploading;
    }

    updateProgressMotion(): void {
        this.progressMotion = false;
        setTimeout(() => {
            this.progressMotion = true;
        });
    }

    // 检查结果计数
    getCount(): StatusCount {
        let all = 0;
        let suc = 0;
        let fail = 0;
        let ignore = 0;
        all = this.checkDetails.length;
        this.checkDetails.forEach((items) => {
            switch (Number(items.checkResult)) {
                case CheckResult.Suc: suc++; break;
                case CheckResult.Fail: fail++; break;
                case CheckResult.Error: fail++; break;
                case CheckResult.Ignore: ignore++; break;
                default:
                    break;
            }
        });
        return { all, suc, fail, ignore };
    }

    // 获取检查结果计数和能否上传状态
    getStatus(): void {
        this.count = this.getCount();
    }

    getSkipItemList(): string {
        const list: number[] = [];
        this.checkDetails.forEach((item) => {
            if (Number(item.checkResult) === CheckResult.Ignore) {
                const items = item.checkItem.split(':');
                if (items.length === 2) {
                    list.push(items[0]);
                }
            }
        });

        return list.length ? list.join(',') : undefined;
    }

    // 执行评估
    preCheck(retry = false): void {
        this.upgradeStatus.checkProgress = 0;
        const skipItem = this.getSkipItemList();
        this.checkDetails = [];
        this.getStatus();
        const params: PreCheckParams = {
            checkType: 'FastUpgradeEvaluate',
            checkCMD: retry ? 1 : 0,
            skipItem,
        };

        if (this.vm.value.targetVersion) {
            Object.assign(params, { extendParam: { targetVersion: this.vm.value.targetVersion } });
        }

        // 下发升级前评估命令
        this.http.put(this.http.makeUrl('upgrade.check'), params).subscribe(
            () => {
                if (!this.authService.getTimeoutExcept()) {
                    // 开始升级前评估,开启超时检测例外
                    this.authService.enableTimeoutExcept();
                }
                this.currentProcess = Progress.evaluating;
                this.createPrecheckPolling();
            },
            () => {
                this.currentProcess = undefined;
                // 关闭超时检测例外
                this.authService.disableTimeoutExcept();
            },
        );
    }

    // 开启评估轮询
    createPrecheckPolling(): void {
        // 不重复创建轮询
        if (this.checkResultPolling) return;
        this.extraPolling = false;
        this.upgradeStatus.checkProgress = 0;
        const restJob: RestJob[] = [{
            rest: this.http.makeUrl('upgrade.checkResult'),
            method: 'GET',
        }, {
            rest: this.http.makeUrl('upgrade.checkProgress'),
            method: 'GET',
        }];
        this.checkResultPolling = this.poll.addCombo(restJob, 20);
        this.checkResultPolling.subscribe((res) => {
            res[0].data.forEach((item) => {
                const sameIndex = this.checkDetails.findIndex((checkDetailItem) => checkDetailItem.checkItem === item.checkItem);
                if (sameIndex > -1) {
                    // 保持页面上详情展开状态
                    item.showDetail = Boolean(this.checkDetails[sameIndex].showDetail);
                    // 已忽略项保持忽略状态
                    if (this.str.isCheckResultFailed(Number(item.checkResult)) &&
                        Number(this.checkDetails[sameIndex].checkResult) === CheckResult.Ignore) {
                        item.checkResult = CheckResult.Ignore;
                        item.skipByUser = true;
                    }
                }
                // 将换行符\n替换为<br>
                if (item.method) {
                    item.method = item.method.replace(/\\n/g, '<br>');
                }
                if (item.criterion) {
                    item.criterion = item.criterion.replace(/\\n/g, '<br>');
                }
                if (item.suggestion) {
                    item.suggestion = item.suggestion.replace(/\\n/g, '<br>');
                }
                if (typeof item.nodeInfo === 'object') {
                    item.nodeInfoArr = Object.keys(item.nodeInfo).map((key) => ({
                        node: key,
                        // 适配升级组接口更新，将换行符\n替换为<br>
                        info: (item.nodeInfo[key] as string).replace(/\\n/g, '<br>'),
                    }));
                }
            });

            // 排序
            this.checkDetails = this.service.checkDetailsSort(res[0].data);

            // 每次轮询更新一下详情数据
            this.updateDetailData();

            this.getStatus();
            this.upgradeStatus = res[1].data;
            const checkStatus = Number(res[1].data.checkStatus);
            if (checkStatus === CheckStatusE.Done || checkStatus === CheckStatusE.Failed) {
                const detailsAllDone = this.service.ifAllDone(this.checkDetails, 'checkResult', DoneStatus);
                // 检查结束但详情并没有全部完成，额外走一次轮询后再停止
                if (!detailsAllDone && !this.extraPolling) {
                    this.extraPolling = true;
                    return;
                }
                this.poll.remove(this.checkResultPolling);
                this.checkResultPolling = null;
                // 检查当前是否所有进程都成功，是否含有失败项
                if (checkStatus === CheckStatusE.Failed ||
                    this.checkDetails.some((value) => this.str.isCheckResultFailed(Number(value.checkResult)))) {
                    this.currentProcess = Progress.evaluateFailed;
                } else {
                    this.currentProcess = Progress.evaluateSuc;
                    this.isShowExport = true;
                }
            }
        });
    }

    /**
     * 展示检查详情
     *
     * @param checkItem 检查项字符串
     */
    onShowCheckDetails(checkItem: string): void {
        const checkDetailData = this.service.getCheckDetailData(checkItem, this.checkDetails);

        if (!checkDetailData) {
            return;
        }

        this.checkDetailDataKey = checkItem;
        if (!this.detailComponent) {
            this.detailComponent = this.lazyLoad.appendComponent(DetailCheckResultUpgradeComponent, {
                onClose: () => {
                    this.detailComponent = null;
                    this.checkDetailDataKey = undefined;
                },
                data: checkDetailData,
            });
        } else {
            // 阻止当前侧滑框被关闭
            if (this.detailComponent.instance.slideWindow) {
                this.detailComponent.instance.slideWindow.isPreventClickHide = true;
            }
        }

        // 初始化触发一次data更新事件，方便详情页处理data更新逻辑
        this.detailComponent.instance.data = checkDetailData;
        this.detailComponent.instance.onDataUpdate(checkDetailData, false);
    }

    onSkipCheckDetails(i): void {
        this.checkDetails[i].checkResult = CheckResult.Ignore;
        this.checkDetails[i].skipByUser = true;
        this.getStatus();
        // 评估失败状态忽略了所有失败项，则设为评估成功
        if (this.currentProcess === Progress.evaluateFailed && this.count.fail === 0) {
            this.currentProcess = Progress.evaluateSuc;
            this.isShowExport = true;
        }
    }

    /**
     * 更新详情数据
     */
    updateDetailData(): void {
        if (!this.detailComponent || isUndefined(this.checkDetailDataKey)) {
            return;
        }
        const checkDetailData = this.service.getCheckDetailData(this.checkDetailDataKey, this.checkDetails);
        // 初始化触发一次data更新事件，方便详情页处理data更新逻辑
        this.detailComponent.instance.data = checkDetailData;
        this.detailComponent.instance.onDataUpdate(checkDetailData, false);
    }

    onClose(): void {
        this.show = false;
    }

    onHide(): void {
        this.lazyLoad.destroySelf(this);
    }

    export(): void {
        this.backupLoading = true;

        // 微存储直通模式屏蔽license导出
        if (SWITCH.IS_DIRECT_MODE) {
            this.service.getDataBaseInportPath()
                .pipe(
                    switchMap(({ data }) => {
                        const { CMO_EXPORT_DB_DATA_DIR } = data;
                        const time = this.timeService.formatUTC(this.timeService.currTime * 1e3, 'YYYYMMDDHHmmss', false);
                        return this.service.backupActivatedDataBase(CMO_EXPORT_DB_DATA_DIR, time);
                    }),
                    finalize(() => {
                        this.backupLoading = false;
                    }),
                ).subscribe({
                    next: (res) => {
                        if (res) {
                            this.isExportSucceed = true;
                            this.isExportLicenseSucceed = true;
                        } else {
                            this.isExportSucceed = false;
                        }
                    },
                });
        } else {
            this.service.getDataBaseInportPath()
                .pipe(
                    switchMap(({ data }) => {
                        const { CMO_EXPORT_DB_DATA_DIR } = data;
                        const time = this.timeService.formatUTC(this.timeService.currTime * 1e3, 'YYYYMMDDHHmmss', false);
                        return this.service.backupActivatedDataBase(CMO_EXPORT_DB_DATA_DIR, time);
                    }),
                    switchMap(() => this.licenseManagementService.getActiveLicenseInportPath().pipe(
                        catchError(({ error }) => {
                            if (error.code === LicenseError.noLicense) {
                                this.isExportSucceed = true;
                                this.isExportLicenseSucceed = false;
                                return of(error);
                            }
                            return throwError(error);
                        }),
                    )),
                    switchMap(({ data }) => {
                        const { CMO_LICENSE_DIR_INFO_DIR } = data;
                        const time = this.timeService.formatUTC(this.timeService.currTime * 1e3, 'YYYYMMDDHHmmss', false);
                        return this.licenseManagementService.backupActivatedLicense(CMO_LICENSE_DIR_INFO_DIR, time);
                    }),
                    finalize(() => {
                        this.backupLoading = false;
                    }),
                ).subscribe({
                    next: () => {
                        this.isExportSucceed = true;
                        this.isExportLicenseSucceed = true;
                    },
                });
        }
    }

    /**
     * 上一步
     */
    previous(): void {
        this.tab.prev();
    }

    /**
     * 下一步
     */
    next(): void {
        this.tab.next();
    }

    ngOnDestroy(): void {
        // 关闭超时检测例外
        this.authService.disableTimeoutExcept();
        if (this.uploadPolling) {
            this.poll.remove(this.uploadPolling);
        }
    }
}
